import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    errors: {
      delayTooHigh:
        'The payment period cannot last more than "45 days end of month" or 60 days',
      invalidIssuerEmail: 'Issuer email is invalid',
      lateFeeTooLow: 'Legally, the minimum late penalty should be {min}%.',
      missingPaymentMethod: 'At least one payment method must be selected',
      missingTasks: 'At least one task must be added',
    },
  },
  fr: {
    errors: {
      delayTooHigh:
        'Le délai de paiement ne peut être supérieur à "45 jours fin de mois" ou 60 jours',
      invalidIssuerEmail:
        'L’adresse électronique de l’émetteur n’est pas valide',
      lateFeeTooLow:
        'Légalement, la pénalité de retard minimum doit être de {min}\xA0%.',
      missingPaymentMethod:
        'Au moins un mode de paiement doit être sélectionné',
      missingTasks: 'Au moins une tâche doit être ajoutée',
    },
  },
} as const);

export default locales;
